<template>
  <div class="DataTables AssemblyDetailsComponent ">

    
    <p v-if="!isRevision">{{lang.infotext_1}}</p>
    <LoaderComponent  v-if="!isData"></LoaderComponent>
    <div :id="id"></div>
    
  </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"


    export default {
        name: "AssemblyDetailsComponent",
        props:{
          lang: Object
        },
        components: {

          LoaderComponent
        },
        data () {
          return {

            mainTable: "",
            id: "AssemblyDetailsComponent",
            parts: [],
            //assemblyRevNumbers: [],
            colorValues: [],
            currentPackage: {},
            packages: {},
            symbolSvg: {},
            place: ""  ,
            currentRevisionId: "",
            
          }
        },
        computed: {
          
          selectedRevisionRow(){
            return this.$store.getters.selectedRevisionRow;
          },
          isData(){
            return this.parts.length == this.$store.getters.selectedRevisionRow.length;
          },
          isRevision(){

            return this.$store.getters.selectedRevisionRow.length != 0;

          },
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          },
          reloadedAfterAction() {
            return this.$store.getters.reloadedAfterAction;
          },
          revisionHistory() {
            return this.$store.getters.revisionHistory;
          },
          lastRevision() {

            
            let lastrev = this.revisionHistory[0];
            for (let i = 0, lei = this.revisionHistory.length; i < lei; i++){
              if (lastrev.revision < this.revisionHistory[i].revision) {
                lastrev = this.revisionHistory[i]
              }
              
            }
            console.log(lastrev)
            return lastrev;
          }
        },
        created () {
          

          this.loadDataForRevisions();

        },
        watch: {
        
          parts: function(newVal, oldVal){
            
            if (this.isData){

                const revisions = [];
                

                for (let i = 0, lei = this.parts.length; i < lei; i++){

                  
                    
                  let obj = {
                    assemblyRevision: this.parts[i].revision.revision,
                    assemblyRevisionId: this.parts[i].revision.revisionId,  
                    isLastRevision: this.parts[i].revision.isLast,
                    parts: this.parts[i].data,
                    
                  }
                  

                  revisions.push(obj)
                }
                                 
                revisions.sort(function(a, b){return a.assemblyRevision-b.assemblyRevision});

              this.buildTable(revisions)
              

            }

          },
          selectedRevisionRow: function (newVal, oldVal) {
            
            
            this.loadDataForRevisions();

          },
          reloadedAfterAction: function (newValue, oldValue) {

            
            if (newValue.name == this.id) {
              if (newValue.status == true) {

                this.loadDataForRevisions();

                newValue.status = false;
                newValue.name = "";
                this.$store.dispatch("reloadAfterAction", newValue);
              }
            }

          },
          
        },
        updated() {

        },
        mounted: function () {
          
        },
        methods: {
          
          loadDataForRevisions(){


            this.parts = []
            //this.assemblyRevNumbers = []

            let vue = this;
            for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++){

              let isLast = false;
              if (i == 0) {
                isLast = true;
              }

              let obj = {
                assemblyRevisionId: this.selectedRevisionRow[i].revisionId,
                revision: { 
                    revision: this.selectedRevisionRow[i].revision,
                    revisionId: this.selectedRevisionRow[i].revisionId,
                    isLast: isLast
                }
              }

              this.$store.dispatch("getAssemblyElements", obj)
              .then(function(result) {
                
                console.log(result)

                //result.data.sort(function(a, b){return a.priority-b.priority});
                
                
                if (result.status == "OK") {
                  
                  
                  vue.parts.push(result);
                } 
                
                
                
                //vue.assemblyRevNumbers.push(result.revision)

              })

            }

          },
          displayParts(data) {

            console.log(data)
            
            
                
                
                let tr = '<tr>' +
                  '<td>' + this.lang.table_header_MpnImage + '</td>' +
                  '<td>' + this.lang.table_header_PartNumber + '</td>'+
                  '<td>' + this.lang.table_header_PartRevision + '</td>'+
                  '<td>' + this.lang.table_header_Quantity + '</td>' +
                  '<td>' + this.lang.table_header_Type + '</td>' +
                  '<td class="width2">' + this.lang.table_header_Actions + '</td>' +
              '</tr>'
                
            for (let i = 0, lei = data.parts.length; i < lei; i++){
              let disabled = "";
              if (data.parts[i].isMain == true) {
                disabled = "disabled=disabled";
              }
              let button = '';
              
              if (data.assemblyRevisionId == this.lastRevision.id) {
                button = '<button class="btn btn-sm btn-' + this.variant + ' button_action_unassign" id=aspart__' + data.parts[i].revisionId + ' ' + disabled + '>' + this.lang.button_UnassignActions + '</button>';
              }
              let main = "";
              if (data.parts[i].isMain == true) {
                main = "   (" + this.lang.label_Main + ")";
                
              }
              
              
              let mpnImage = "";
              if ((data.parts[i].mpnImage != null) && (data.parts[i].mpnImage != "") && ((data.parts[i].mpnImage.indexOf("http://") != -1) || (data.parts[i].mpnImage.indexOf("https://") != -1))) {

                mpnImage = "<img class=\"img-thumbnail img-fluid\" height='40px' src='" + data.parts[i].mpnImage + "'>";
              } else {
                console.log(data.parts[i].type)
                if (data.parts[i].type == "Electric") {
                  mpnImage = "<img class=\"img-thumbnail  img-fluid\" height='40px' src='/static/electrical-part.svg'>";
                }
                if (data.parts[i].type == "Mechanical") {
                  mpnImage = "<img class=\"img-thumbnail  img-fluid\" height='40px' src='/static/mechanical-part.svg'>";
                }
                if (data.parts[i].type == "Software") {
                  mpnImage = "<img class=\"img-thumbnail  img-fluid\" height='40px' src='/static/software-part.svg'>";
                }
              }
              
              tr += '<tr>'+
                  
                '<td class="width1">' + mpnImage + '</td>' +
                '<td class="width3">' + data.parts[i].partNumber + ' ' + main + '</td>'+
                '<td class="width4">' + data.parts[i].revision + '</td>'+
                '<td class="width5">' + data.parts[i].quantity + '</td>' +
                '<td class="width6">' + data.parts[i].type + '</td>' +
                '<td class="width7">' + button + '</td>' +                              
                  
              '</tr>'
                }     
                
            const table =  '<table cellpadding="0" cellspacing="0" border="0" style="margin-left:44px;">'+
                tr +
    
            '</table>';
                    

            return table;
          },
          buildTable(_dataTable){
            
            

            var tableplace = document.getElementById(this.id);

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("style", "width:100%");
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "headerCell");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            let _vue = this;


            let columns = [
                {
                name: this.lang.table_header_Expand,
                alignInColumn: "left",
                type: "text",
                width: 50
                }, 
                
                {
                name: this.lang.table_header_Revision,
                alignInColumn: "left",
                type: "text"
                },
                // {
                // name: this.lang.table_header_PartNumber,
                // alignInColumn: "left",
                // type: "text"
                // },
                // {
                // name: this.lang.table_header_PartRevision,
                // alignInColumn: "left",
                // type: "taxt"
                // },
                // {
                // name: this.lang.table_header_Quantity,
                // alignInColumn: "left",
                // type: "text"
                // }
                
                
            ]

            this.colsAssign =  [
                
                {
                    "className": 'details-control',
                    "orderable": false,
                    "data": null,
                    "defaultContent": ''
                },
                
                { "data": "assemblyRevision" },
                // { "data": "assemblyRevision" },
                // { "data": "assemblyRevision" },
                // { "data": "assemblyRevision" },
                
                    
            ]

            

            
            


            var columnDefs = [];
            
            for (var i = 0, len = columns.length; i < len; i++){

              let classname = '_dt-body-'+ columns[i].alignInColumn;

              let  el = {
                  targets: i,
                  className: classname,
                  render: function ( data, type, row, meta ) {

                    if (meta.col == 0){
                                                
                        
                        return '<img src="/static/minus.svg">';
                    }  

                    // if (meta.col == 2){
                    //     return "";
                    // }
                    // if (meta.col == 3){
                    //     return "";
                    // }
                    // if (meta.col == 4){
                    //     return "";
                    // }
                    

                    return data;
                  }
                }

                columnDefs.push(el);

                columnDefs.push({ "width": "50px", "targets": 0 })
                // columnDefs.push({ "width": "100px", "targets": 1 })
                // columnDefs.push({ "width": "100px", "targets": 2 })
                // columnDefs.push({ "width": "100px", "targets": 3 })
                //columnDefs.push({ "width": "100px", "targets": 4 })

              
                var th = document.createElement("th");
                tr.appendChild(th);
                var br = document.createElement("br");
                th.appendChild(br);
                var tx = document.createTextNode(columns[i].name)
                th.appendChild(tx);

              
            }


            var option = {};
            option.paging = false;
            option.info = false;
            option.dom = 'f<t>';
            option.data= _dataTable;
            option.myColumnFormats = columns;
            option.select = false;
            option.columns = this.colsAssign;
            option.columnDefs = columnDefs;
            option.order = [1, "desc"];

            if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
                this.mainTable.destroy();
                console.log("DESTROY TABLE")
            }



            this.mainTable = $('#t_'+this.id).DataTable(option);

            
            this.mainTable.columns.adjust().draw();

            

            //hide first column in table
            //this.mainTable.column( 0 ).visible( false );
            //this.mainTable.column( 1 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:"){
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

            let _mainTable = this.mainTable;
            
            $('#t_'+this.id +' tbody').on('click', 'td.details-control', function (e) {
            
            
                var tr = $(this).closest('tr');
                var row = _mainTable.row( tr );
              
                if ( row.child.isShown() ) {
                    // This row is already open - close it
                    e.target.src = "/static/plus.svg";
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row
                    e.target.src = "/static/minus.svg";
                    row.child( _vue.displayParts(row.data()) ).show();
                    tr.addClass('shown');
                }
            });  

            
            

            _mainTable.rows(':not(.parent)').nodes().to$().find('td:first-child').trigger('click');


            $('#t_' + this.id + ' tbody').on('click', '.button_action_unassign', function (e) {



              let temp = e.target.id.split("__");

              function funcAssemblyYes() {
                const obj = {
                  partRevisionId: parseInt(temp[1]),
                  assemblyRevisionId: _vue.selectedRevisionRow[0].revisionId,
                  Quantity: _vue.$store.getters.assemblyQuantity.quantity
                }

                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_unassignAssembly", obj)
                  .then((result) => {

                    console.log(result)

                    if (result.status == "OK") {
                      if (result != null) {

                        let obj = {
                          text: _vue.lang.alert_success_unassign,
                          time: 10,
                          type: "success"
                        }

                        _vue.$store.dispatch("displayFooterAlert", obj);

                        const reloadObj = {
                          status: true,
                          name: "RevisionTableComponent"
                        }
                        _vue.$store.dispatch("reloadAfterAction", reloadObj);

                      } else {
                        let obj = {
                          text: _vue.lang.alert_error_unassign + ". ",
                          time: 15,
                          type: "danger"
                        }

                        _vue.$store.dispatch("displayFooterAlert", obj);

                      }

                    } else {
                      let obj = {
                        text: _vue.lang.alert_error_unassign + ": " + result.message,
                        time: 15,
                        type: "danger"
                      }

                      _vue.$store.dispatch("displayFooterAlert", obj);
                    }
                  })
                
              }

             //display quantity modal
              var obj = {

                text: "",
                type: "assemblyquantity",
                buttons: 2,
                size: "lm",
                //data: null,
                lang: _vue.lang.modal_QuantityForAssembly,
                funcNo: "",
                funcYes: funcAssemblyYes
              };
              _vue.$store.dispatch("showModalComponent", obj);

              

              
              

              
            });  
          },

        }

    }
</script>
<style lang="scss">
@import "./../../scss/_custom.scss";

  .AssemblyDetailsComponent{
    table{

      padding: 0px !important;

    }
    table th {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }

    table td {
      padding: 0rem !important;

      padding-left: 3px !important;
      padding-right: 3px !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_filter{
      font-size: 10px;
    }
    .searcher{
      float: left;
    }
    .dataTables_filter .form-control-sm {
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $redfont;
      font-weight: 700;
    }
    .blue{
      color: $blue;
      font-weight: 700;
    }
    .yellow{
      color: $yellow;
      font-weight: 700;
    }
    .red-img{
      background-color: $red;
      border: 0px;
    }
    .green{
      color: $green;
      font-weight: 700;
    }
    .green-img{
      background-color: $green;
      border: 0px;
    }
    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }

    .btn{
      height: 26px;
    }
    td{
      word-break: break-all;
    }
    td.details-control {
      //background: url("/static/plus.svg") no-repeat center center;
      img{
        max-width: 30px;
        padding: 2px;  
      }
      
    }
    tr.shown td.details-control {
      img{
        max-width: 30px;
        padding: 2px;  
      }
      //background: url("/static/minus.svg") no-repeat center center;
    }
    .width1{
        width: 110px;
    }
    .width2{
        width: 100px;
    }
    .width3{
        width: 30%;
    }
    .width4{
        width: 15%;
    }
    .width5{
        width: 15%;
    }
    .width6 {
        width: 15%;
    }
    .width7 {
        width: 15%;
    }
    .btn {
      padding-top: 3px;
      padding-bottom: 3px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }

    .button_action_unassign {
      margin: 3px 3px 3px 3px;
    }
    .img-thumbnail{
      max-width: 100px;
      max-height: 100px;
    
      margin-top: 3px;
      margin-bottom: 3px;
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/AssemblyDetailsComponent.vue